// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1784258638953
      var cssReload = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  